<div class="ui-dt__pagination">
  <span class="ui-dt__pag-info">
    @if (total() > 0) {
      Mostrando {{ rangeStart() }}–{{ rangeEnd() }} de {{ total() }}
    } @else {
      Sin registros
    }
  </span>

  <div class="ui-dt__pag-pages">
    <!-- Primera página -->
    <button
      type="button"
      class="ui-dt__pag-btn"
      [disabled]="isFirst()"
      (click)="first()"
      title="Primera página"
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="13 7 8 12 13 17"/><polyline points="19 7 14 12 19 17"/>
      </svg>
    </button>

    <!-- Página anterior -->
    <button
      type="button"
      class="ui-dt__pag-btn"
      [disabled]="isFirst()"
      (click)="prev()"
      title="Página anterior"
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="15 18 9 12 15 6"/>
      </svg>
    </button>

    @for (p of visiblePages(); track $index) {
      @if (p === -1) {
        <span class="ui-dt__pag-ellipsis">…</span>
      } @else {
        <button
          type="button"
          class="ui-dt__pag-btn"
          [class.ui-dt__pag-btn--active]="p === currentPage()"
          (click)="goToPage(p)"
        >{{ p + 1 }}</button>
      }
    }

    <!-- Página siguiente -->
    <button
      type="button"
      class="ui-dt__pag-btn"
      [disabled]="isLast()"
      (click)="next()"
      title="Página siguiente"
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="9 18 15 12 9 6"/>
      </svg>
    </button>

    <!-- Última página -->
    <button
      type="button"
      class="ui-dt__pag-btn"
      [disabled]="isLast()"
      (click)="last()"
      title="Última página"
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="11 7 16 12 11 17"/><polyline points="5 7 10 12 5 17"/>
      </svg>
    </button>
  </div>
</div>
